// extracted by mini-css-extract-plugin
module.exports = {"contacts":"contacts-module--contacts--2kGfD"};